import gql from 'graphql-tag';

export const CREATIVE_IMAGES_QUERY = gql`
  query CreativeImages($imagesPerPage: Int!, $after: String, $articleGroupId: ID!, $creativeImageIds: [ID!]) {
    creativeImages(
      first: $imagesPerPage
      after: $after
      articleGroupId: $articleGroupId
      creativeImageIds: $creativeImageIds
    ) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          id
          url
          imageType
          metrics {
            ctr
            spent
          }
        }
      }
    }
  }
`;
